import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AvGlobalLoaderComponent } from '../../Shared/Components/global-loader/global-loader.component';
import { ThemeService } from '../../Shared/Services/theme.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, AvGlobalLoaderComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class App {
  constructor() {
    inject(ThemeService);
  }
}
